/** Tab indices on brewery manager (`BreweryDetailsTabs`). */
export const BREWERY_BEERS_TAB_INDEX = 2;
export const BREWERY_SOURCES_TAB_INDEX = 3;
export const BREWERY_INGESTION_RUNS_TAB_INDEX = 4;
export const BREWERY_BEER_DUPES_TAB_INDEX = 5;
export const BREWERY_CLAIM_USERS_TAB_INDEX = 6;
export const BREWERY_MAX_TAB_INDEX = 6;
